import { render, staticRenderFns } from "./CardCorporationLogo.vue?vue&type=template&id=6ab3036b"
import script from "./CardCorporationLogo.vue?vue&type=script&lang=ts"
export * from "./CardCorporationLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports